/**
 * Assets en /public (CRA: PUBLIC_URL).
 */
const pub = typeof process !== "undefined" && process.env && process.env.PUBLIC_URL != null
	? String(process.env.PUBLIC_URL).replace(/\/$/, "")
	: "";

function asset(path) {
	const p = path.startsWith("/") ? path : `/${path}`;
	return pub ? `${pub}${p}` : p;
}

export const EVENELY_LOGO_BLACK_URL = asset("/logo-evenely-black.webp");
export const EVENELY_LOGO_WHITE_URL = asset("/logo-evenely-white.webp");
export const EVENELY_LOGO_BLACK_FALLBACK_URL = asset("/ersaas-logo.png");
/** @deprecated usar EVENELY_LOGO_BLACK_URL */
export const EVENELY_LOGO_URL = EVENELY_LOGO_BLACK_URL;
export const EVENELY_FAVICON_SVG = asset("/favicon.svg");
export const EVENELY_FAVICON_32 = asset("/favicon32.png");
export const EVENELY_FAVICON_64 = asset("/favicon64.png");
